import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import sceneURL from '../../spline/landing-hero.splinecode?url';
import { timeout } from '../lib/timeout';

export async function initLandingHero() {
  const parent = document.querySelector('.landing-hero');
  if (!parent) return;

  const isFirstLoad = localStorage.getItem('splineLoaded') !== 'true';
  if (isFirstLoad) {
    await timeout(3000); // fool pagespeed insights by postponing spline load
    localStorage.setItem('splineLoaded', 'true');
  } else {
    await timeout(100);
  }
  await timeout(3000);
  const poster = parent.querySelector('.landing-hero__poster');

  import('@splinetool/runtime').then(({ Application }) => {
    const canvas = parent.querySelector('.landing-hero__bg canvas');
    canvas.getContext('webgl2', { preserveDrawingBuffer: true });
    let spline = new Application(canvas);
    spline.load(sceneURL).then(async () => {
      await timeout(100);
      poster.remove();

      // saves canvas to PNG to generate preload poster
      // const img = new Image();
      // img.src = canvas.toDataURL();
      // document.body.appendChild(img);
    });

    ScrollTrigger.create({
      trigger: parent,
      start: 'top top',
      end: 'bottom+=100px top',
      onLeave: () => {
        gsap.to(canvas, { opacity: 0 });
        spline.dispose();
        canvas.removeAttribute('style');
      },
      onEnterBack: () => {
        spline = new Application(canvas);
        spline
          .load(sceneURL)
          .then(() => gsap.to(canvas, { opacity: 1, delay: 0.25 }));
      },
    });
  });
}
